import React, { useEffect, useState } from "react";
import axios from "axios";
import { makeStyles, withStyles } from "@mui/styles";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import styled from "styled-components";
import { putMBMEquipmentAlarms } from "services/ConfigServices";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import Button from "@mui/material/Button";
import { NotificationManager } from "react-notifications";
import { equipmentalarmsstext } from "variables/MBM/equipments";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const CommentDiv = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  background-color: #91c73c1c;
  border: solid;
  border-width: thin;
  border-color: #91c73c4d;
  margin-bottom: 10px;
`;
const CommentTitle = styled.div`
  padding: 0.25rem 0.25rem;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  justify-content: space-between;
`;
const CommentAuthor = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  font-weight: 600;
`;
const CommentDate = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const CommentContent = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;


function AcquitmentDialog(props) {
  const { closeModal, refetch, currentAlert } = props;

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [newcomment, setNewcomment] = useState("");


  useEffect(() => {
    if (newcomment.length > 0)
      setButtonDisabled(false);
    else
      setButtonDisabled(true);
  }, [newcomment]);
  const classes = useStyles();


  const handleCommentChange = (event) => { setNewcomment(event.target.value) };

  const handleSubmit = (event) => {
    updateComment();
  };

  const updateComment = async (event) => {
    let author = `${UserService.getFirstName()} ${UserService.getLastName()}`;
    let date = moment();
    let content = newcomment;
    let acquitment = { author: author, date: date, content: content, acquited: "yes" };
    axios
      .put(
        putMBMEquipmentAlarms(currentAlert.id, "acquitment"),
        acquitment
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          refetch();
          closeModal();
          currentAlert.acquitment = acquitment;
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {
            (currentAlert?.acquitment?.acquited && currentAlert.acquitment.acquited === 'yes') ?
              <CommentDiv>
                <CommentTitle><CommentAuthor>{currentAlert.acquitment.author}</CommentAuthor><CommentDate>{moment(currentAlert.acquitment.date).format("YYYY-MM-DD HH:mm")}</CommentDate></CommentTitle>
                <CommentContent>{currentAlert.acquitment.content.split('\n').map(str => <p>{str}</p>)}</CommentContent>
              </CommentDiv>
              : <></>
          }
        </GridItem>
      </GridContainer>
      {(!currentAlert?.acquitment?.acquited || currentAlert?.acquitment?.acquited === 'no') ?
        <>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <TextInput
                  multiline
                  rows={4}
                  textInput={newcomment}
                  handleTextInputChange={handleCommentChange}
                  autoFocus
                />
              </div>
            </GridItem>
          </GridContainer>
          <CommentContent>{equipmentalarmsstext.warningacquitment}</CommentContent>
          <Button
            disabled={buttonDisabled}
            className={
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
            }
            onClick={() => {
              handleSubmit();
            }}
          >
            Acquiter
          </Button></>
        : <></>
      }

    </>
  );
}

export default AcquitmentDialog;
